import React, { Component } from "react";
import "./Header.css";

export default class Header extends Component {
  render() {
    const toggleIcon = this.props.fullscreen ? "minimize" : "maximize";
    return (
      <div id="header">
        <div className="room-name">{this.props.headerTitle}</div>

        {/* <div className="button" onClick={() => this.props.handleFullscreen()}> */}
        <div className="button" style={{opacity: 0}}>
          <div>
            <i className={"icon-" + toggleIcon} />
          </div>
        </div>

        <div className="button" onClick={() => this.props.handleOptions(true)}>
          <div>
            <i className="icon-more-vertical" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/header/Header.js